module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_autocomplete-3167ab0111eae68abde4e751c4cc5ba9.jpg";